/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PARAMETERS_CODE } from 'app-constants'
import { parameterService } from 'services'

const initialState = {
  [PARAMETERS_CODE.ENABLE_SEARCH_FAQ_AI]: false,
}

const { getParameter } = parameterService()

export const getParameterByCode = createAsyncThunk(
  'parameters/byCode',
  async (parameterCode, { rejectWithValue }) => {
    try {
      const { data } = await getParameter(parameterCode)

      return { active: data.active, parameterCode }
    } catch (error) {
      return rejectWithValue({ parameterCode })
    }
  }
)

const parametersSlice = createSlice({
  name: 'parameters',
  initialState,
  reducers: {
    setParameter: (state, action) => {
      const { key, value } = action.payload
      state[key] = value
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getParameterByCode.fulfilled, (state, action) => {
        const { parameterCode, active } = action.payload
        state[parameterCode] = active
      })
      .addCase(getParameterByCode.rejected, (state, action) => {
        const { parameterCode } = action.payload
        state[parameterCode] = false
      })
  },
})

export const { setParameter } = parametersSlice.actions

export default parametersSlice.reducer
